import { render, staticRenderFns } from "./RecruitmentOrders.vue?vue&type=template&id=18c2198e&scoped=true"
import script from "./RecruitmentOrders.vue?vue&type=script&lang=js"
export * from "./RecruitmentOrders.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentOrders.vue?vue&type=style&index=0&id=18c2198e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c2198e",
  null
  
)

export default component.exports